import React from "preact/compat";
import {h, Component} from 'preact';
import {connect} from "react-redux";
import reduce from "../reducers";
import * as actions from "../actions";
import wordArt, { wrapToCurve } from "../canvas/word-art";
import Interactable from "../canvas/interactable";
import util, {roundOneDecimalScaled} from '../util';
import renderer from "../canvas/renderer";
import Text from "../canvas/text";
import { reselect } from "../canvas/selection";

export default @connect(reduce, actions)
class WordArtCurveControls extends Component {
    constructor() {
        super();

        this.curveOff = () => {
            const $element = this.props.$element;
            if (!$element) return;
            $element.attr('data-text-wrapped', "false");
            this.props.updateElementAttribute('textWrapped', false);
            $element.attr('data-curve-value', "1");
            this.props.updateElementAttribute('curveValue', "1");
            Text.ensureTextSize($element);
            Interactable.refreshControls();
        }
    
        this.curveOn = () => {
            const $element = this.props.$element;
            if (!$element) return;

            if (!this.props.textWrapped) {
              const qlEditorFirstChild = $element.find('.ql-editor').children().get(0);
              const activeDims = util.getActiveDimensions();
              const setWidth = Math.min(util.pixelToPercent(wordArt.getTextWidth(qlEditorFirstChild.innerText, wordArt.getCanvasFont(qlEditorFirstChild)) + 20, activeDims.width),
                                      100);
              $element.width(setWidth + '%');

              let passedFontSize = 0;
              passedFontSize = roundOneDecimalScaled(this.props.fontSize);
              this.props.updateElementAttribute('textWrapped', true);
              wrapToCurve($element, passedFontSize !== 0 ? passedFontSize : false);
              Text.ensureTextSize($element);
              Interactable.refreshControls();
            }
        }

        this.updateCurve = (ev) => {
            const $element = this.props.$element;
            if (!$element) return;

            let val = ev.target.value;
            if (parseFloat(val) === 0) {
                val = 0.05;
            }
            let passedFontSize = 0;
            if (!this.props.textWrapped) {
              passedFontSize = roundOneDecimalScaled(this.props.fontSize * this.getScale());
            }
            this.props.updateElementAttribute('curveValue', val);
            $element.attr('data-curve-value', val);
            wrapToCurve($element, passedFontSize !== 0 ? passedFontSize : false);
            Text.ensureTextSize($element);
        };

        this.clearFillAndLine = () => {
          const $element = this.props.$element;
          renderer.updateTextFill($element, 
            {
              "mode": "no-fill",
              "colors": [
                "rgb(255, 255, 255)",
                "rgb(0, 0, 0)"
              ]
            });
          renderer.updateElementStyle($element, 'border-bottom', `0rem solid ${this.props.color}`);
          $element.attr('data-bb-width', 0);
          this.props.updateElementAttribute('borderBottomWidth', 0);
        }
    }

    render(props, state) {
        const isCurved = props.$element && props.textWrapped;
        return (
            <div className="curve-controls">
              <div className="title">Curve</div>
              <div className="separator"/>
                <ul className="curve-toggles">
                    <li className={isCurved ? '' : 'act'} onClick={() => this.curveOff()}>
                        <div className="straight-text">ABCD</div>
                        <div className="label">None</div>
                    </li>
                    <li className={isCurved ? 'act' : ''} onClick={() => this.curveOn()}>
                        <img src="https://timber.mhmcdn.com/site/timber/ABCDCurvedRed.svg" alt="Curve Text"/>
                        <div className="label">Curve</div>
                    </li>
                </ul>

                <ul className="slider-list" style={!isCurved ? "visibility: hidden;" : ""}>
                  <li className="slider-item">
                    <label>Curve</label>
                    <div className="toolbar-wrap">
                      <input className="slider" type="range" min="-2" max="2" step=".05" value={props.curveValue} onChange={this.updateCurve.bind(this)}
                              onMouseMove={(ev) => this.updateCurve(ev)}/>
                    </div>
                    <input className="value" type="number" min="-2" max="2" step=".05" disabled="disabled" value={props.curveValue * 20}/>
                  </li>
                </ul>
            </div>)
    }
}
